import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';

type ParamsResult<T extends readonly string[]> = {
  [Key in T[number]]: string | null;
};

export default function useURLSearchParams<T extends readonly string[]>(...paramNames: T) {
  const history = useHistory();
  const initialSearchParams = new URLSearchParams(history.location.search);
  const params = paramNames.reduce((paramMap, name) => {
    paramMap[name] = initialSearchParams.get(name);
    return paramMap;
  }, {}) as ParamsResult<T>;

  function updateUrl(data: { [key: string]: string | number | boolean }) {
    const searchParams = new URLSearchParams(history.location.search);
    paramNames.forEach((name) => {
      searchParams.set(name, data[name].toString());
    });
    history.replace({
      pathname: history.location.pathname,
      search: searchParams.toString(),
    });
  }
  return useMemo(() => {
    return { params, updateUrl };
  }, [params]);
}
